import helpData from 'data/help/helpData.json';

interface Step {
  description: string;
  image: string;
  video: string;
}

interface Article {
  id: string;
  title: string;
  content: string;
  steps: Step[];
}

interface Category {
  id: string;
  title: string;
  icon: string;
  description: string;
  articles: Article[];
}

/**
 * Get help category by ID
 * @param categoryId - The ID of the category to fetch
 * @returns Category object or null if not found
 */
export const getHelpCategoryById = (categoryId: string): Category | null => {
  const categories: Category[] = helpData.categories || [];
  return categories.find(cat => cat.id === categoryId) || null;
};

/**
 * Get help article by category ID and article ID
 * @param categoryId - The ID of the category
 * @param articleId - The ID of the article
 * @returns Article object or null if not found
 */
export const getHelpArticleById = (categoryId: string, articleId: string): Article | null => {
  const category = getHelpCategoryById(categoryId);
  if (!category) return null;
  return category.articles.find(article => article.id === articleId) || null;
};

/**
 * Get all help categories
 * @returns Array of all categories
 */
export const getAllHelpCategories = (): Category[] => {
  return helpData.categories || [];
};
